import React, {Fragment} from "react";
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {LeaveWithoutSavingWarningUtility} from "../common/LeaveWithoutSavingWarningUtility";
import {ApiUtility} from "../common/ApiUtility";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";
import {LoadingIndicator} from "../common/LoadingIndicator";
import {useModelUpdateEngine} from "../common/hooks/useModelUpdateEngine";
import {FpServiceTypeForm} from "./FpServiceTypeForm";

export const UpdateFpServiceType = function (props) {
    const modelUpdateEngine = useModelUpdateEngine(
        ApiUtility.getFpServiceType,
        ApiUtility.updateFpServiceType,
        props.fpServiceTypeId,
        'defaults',
        () => {
            modelUpdateEngine.renderableData.updateAndRender({loading: false})
            if (props.afterSuccessfulSave) {
                props.afterSuccessfulSave()
            }
        }
    );

    return (
        <div className="sub-form-container fp-service-type-form-container">
            <ConditionalRenderer if={modelUpdateEngine.renderableData.loading} renderer={() => (
                <div className="sub-form-loading-indicator-container">
                    <OverlayLoadingIndicator/>
                </div>
            )}/>
            <ConditionalRenderer if={modelUpdateEngine.renderableData.model} renderer={() => (
                <Fragment>
                    <div className="sub-form-header">
                        <div className="sub-form-header-text">
                            {modelUpdateEngine.renderableData.model.name} Defaults
                        </div>
                    </div>
                    <div className="sub-form">
                        <FpServiceTypeForm
                            cancel={props.cancel}
                            save={modelUpdateEngine.updateModel}
                            fpServiceType={modelUpdateEngine.renderableData.model}
                        />
                    </div>
                </Fragment>
            )}/>
        </div>
    );
}
